"use strict";
exports.__esModule = true;
exports.onboardedPendingAgreementsResponse = exports.onboardedAgreementsResponse = exports.onboardingAgreementsResponse = void 0;
var domain_1 = require("@genoa/domain");
exports.onboardingAgreementsResponse = {
    ok: true,
    data: {
        agreements: {
            pending: [
                {
                    agreement_type: domain_1.AgreementType.AUTOPAY_AUTHORIZATION,
                    agreement_type_name: 'Autopay Authorization',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-09-27',
                    agreement_url: 'https://getflex.com/autopay-authorization/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: null,
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.NONE
                },
                {
                    agreement_type: domain_1.AgreementType.LEAD_CREDIT_LINE_AGREEMENT,
                    agreement_type_name: 'Credit Line Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://getflex.com/credit-line-agreement/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: null,
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.APP_OPEN_BLOCKING
                },
                {
                    agreement_type: domain_1.AgreementType.TRUTH_IN_LENDING_DISCLOSURE,
                    agreement_type_name: 'Truth in Lending Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://agreements.qa.getflex.com/brb_tila_2023-01-26.md',
                    agreement_url_source_type: domain_1.AgreementSourceType.MARKDOWN,
                    agreement_data: null,
                    date_accepted: null,
                    sendable: true,
                    acceptance_policy: domain_1.AcceptancePolicyType.APP_OPEN_BLOCKING
                },
            ],
            accepted: []
        }
    },
    error: null
};
exports.onboardedAgreementsResponse = {
    ok: true,
    data: {
        agreements: {
            pending: [],
            accepted: [
                {
                    agreement_type: domain_1.AgreementType.AUTOPAY_AUTHORIZATION,
                    agreement_type_name: 'Autopay Authorization',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-09-27',
                    agreement_url: 'https://getflex.com/autopay-authorization/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.NONE
                },
                {
                    agreement_type: domain_1.AgreementType.CREDIT_LINE_AGREEMENT,
                    agreement_type_name: 'Credit Line Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://getflex.com/credit-line-agreement/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.APP_OPEN_BLOCKING
                },
                {
                    agreement_type: domain_1.AgreementType.ESIGN_CONSENT_AGREEMENT,
                    agreement_type_name: 'E-Sign Consent Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://getflex.com/legal/esign-consent/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.NONE
                },
                {
                    agreement_type: domain_1.AgreementType.TERMS_AND_CONDITIONS,
                    agreement_type_name: 'Terms and Conditions',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://getflex.com/terms/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.NONE
                },
                {
                    agreement_type: domain_1.AgreementType.BRB_TRUTH_IN_LENDING_DISCLOSURE,
                    agreement_type_name: 'Truth in Lending Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://agreements.qa.getflex.com/brb_tila_2023-01-26.md',
                    agreement_url_source_type: domain_1.AgreementSourceType.MARKDOWN,
                    agreement_data: {
                        name: 'Mocked User',
                        address: 'Mocked Address, 000000, NY',
                        mmf: '$14.99',
                        amf: '$179.88'
                    },
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: true,
                    acceptance_policy: domain_1.AcceptancePolicyType.APP_OPEN_BLOCKING
                },
            ]
        }
    },
    error: null
};
exports.onboardedPendingAgreementsResponse = {
    ok: true,
    data: {
        agreements: {
            pending: [
                {
                    agreement_type: domain_1.AgreementType.CREDIT_LINE_AGREEMENT,
                    agreement_type_name: 'Credit Line Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://getflex.com/credit-line-agreement/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.APP_OPEN_BLOCKING
                },
                {
                    agreement_type: domain_1.AgreementType.BRB_TRUTH_IN_LENDING_DISCLOSURE,
                    agreement_type_name: 'Truth in Lending Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://agreements.qa.getflex.com/brb_tila_2023-01-26.md',
                    agreement_url_source_type: domain_1.AgreementSourceType.MARKDOWN,
                    agreement_data: {
                        name: 'Mocked User',
                        address: 'Mocked Address, 000000, NY',
                        mmf: '$14.99',
                        amf: '$179.88'
                    },
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: true,
                    acceptance_policy: domain_1.AcceptancePolicyType.APP_OPEN_BLOCKING
                },
            ],
            accepted: [
                {
                    agreement_type: domain_1.AgreementType.AUTOPAY_AUTHORIZATION,
                    agreement_type_name: 'Autopay Authorization',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-09-27',
                    agreement_url: 'https://getflex.com/autopay-authorization/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.NONE
                },
                {
                    agreement_type: domain_1.AgreementType.ESIGN_CONSENT_AGREEMENT,
                    agreement_type_name: 'E-Sign Consent Agreement',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://getflex.com/legal/esign-consent/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.NONE
                },
                {
                    agreement_type: domain_1.AgreementType.TERMS_AND_CONDITIONS,
                    agreement_type_name: 'Terms and Conditions',
                    is_latest: true,
                    agreement_version: 1,
                    agreement_version_name: '2023-10-26',
                    agreement_url: 'https://getflex.com/terms/',
                    agreement_url_source_type: domain_1.AgreementSourceType.WEBSITE,
                    agreement_data: null,
                    date_accepted: '2019-08-24T14:15:22Z',
                    sendable: false,
                    acceptance_policy: domain_1.AcceptancePolicyType.NONE
                },
            ]
        }
    },
    error: null
};
